/* eslint-disable react-refresh/only-export-components */
import { useEffect } from "react";
import { App } from "antd";
import type { MessageInstance } from "antd/es/message/interface";

let messageInstance: MessageInstance | null = null;
// Буфер за toast съобщения, които идват преди bridge-ът да се монтира
// (react-query може да фалне заявка преди App контекстът да е готов).
const pending: string[] = [];
const pendingInfo: { text: string; durationSeconds?: number }[] = [];

export function showGlobalErrorToast(text: string) {
  // Defer-ваме до следващия tick: ако subscribe-ът се вика по време на
  // React render, antd message portal-ът може още да не е готов.
  // setTimeout(0) също гарантира, че MessageBridge е успял да регистрира
  // инстанцията преди първите query грешки.
  setTimeout(() => {
    if (messageInstance) {
      messageInstance.error(text);
    } else {
      pending.push(text);
    }
  }, 0);
}

// Същият път, но за съобщение, което не е грешка (напр. „браузърът ще поиска
// достъп до локалната мрежа" — `lib/edge/edgePermission.ts`). Държи се по-дълго
// на екрана от подразбирането: излиза до подкана на браузъра, която човекът
// тепърва чете.
export function showGlobalInfoToast(text: string, durationSeconds?: number) {
  setTimeout(() => {
    if (messageInstance) {
      messageInstance.info(text, durationSeconds);
    } else {
      pendingInfo.push({ text, durationSeconds });
    }
  }, 0);
}

// Регистрира message инстанцията от App.useApp() в глобален ref,
// за да може да се ползва извън React дървото (напр. в QueryCache.onError).
export function MessageBridge() {
  const { message } = App.useApp();
  useEffect(() => {
    messageInstance = message;
    // Flush буферираните съобщения, натрупани преди монтирането.
    while (pending.length > 0) {
      const text = pending.shift();
      if (text) message.error(text);
    }
    while (pendingInfo.length > 0) {
      const item = pendingInfo.shift();
      if (item) message.info(item.text, item.durationSeconds);
    }
    return () => {
      if (messageInstance === message) messageInstance = null;
    };
  }, [message]);
  return null;
}
